import classNames from 'classnames'
import { Box, Tooltip } from '@material-ui/core'
import { Typography, Icon } from 'src/modules/core/components'
import classes from './form-control.module.scss'
import type { FormControlProps } from './form-control.interfaces'

export function FormControl({
  label,
  error,
  className,
  labelClassName,
  tooltip,
  tooltipPlacement = 'top',
  children,
}: FormControlProps & { children: React.ReactNode }) {
  return (
    <div className={classNames(classes.inputWrapper, className)}>
      {label && (
        <Box className={classes.labelWrapper} display="flex" alignItems="center">
          <Typography
            className={classNames(classes.label, labelClassName, {
              [classes.labelError]: !!error,
            })}
            variant="body"
          >
            {label}
          </Typography>
          {tooltip && (
            <Tooltip
              title={
                <Typography variant="body" className={classes.tooltipText}>
                  {tooltip}
                </Typography>
              }
              placement={tooltipPlacement}
              arrow
            >
              <Box component="span" className={classes.tooltipIconContainer}>
                <Icon name="questionMark" />
              </Box>
            </Tooltip>
          )}
        </Box>
      )}
      {children}
      {error && (
        <Typography className={classes.error} variant="body">
          {error}
        </Typography>
      )}
    </div>
  )
}
